import { render, staticRenderFns } from "./InteractiveDataShow.vue?vue&type=template&id=5bbf2e22&scoped=true&"
import script from "./InteractiveDataShow.vue?vue&type=script&lang=ts&"
export * from "./InteractiveDataShow.vue?vue&type=script&lang=ts&"
import style0 from "./InteractiveDataShow.vue?vue&type=style&index=0&id=5bbf2e22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbf2e22",
  null
  
)

export default component.exports